import { SxProps, Theme } from "@/common/styles/style";

export const styles: { [key: string]: SxProps<Theme> } = {
  paperSearch: {
    padding: "2px 4px",
    display: "flex",
    alignItems: "center",
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    borderRadius: "5px"
  },
  searchArea: {
    marginLeft: 1,
    flex: 1,
  },
  searchAreaButton: {
    padding: "5px",
  },
  searchDivider: { height: 28, margin: 0.5 },
};
